<template>
  <div class="dashboard-container d-flex flex-column align-items-center fade-in h-100" :class="{ 'member-board-active': memberBoardExpanded && isTabletAndSmaller }">
    <!-- Member board for mobile/tablet -->
    <div class="member-board-small-screensize" v-if="isTabletAndSmaller" id="member-board-mobile">
      <member-board @memberBoardStateChanged="handleMemberBoardStateChange"/>
      <div class="renewal-container-mobile">
        <renewal-notifications />
      </div>
    </div>
    <!-- Member board for desktop -->
    <div class="member-board" v-else id="member-board-desktop">
      <member-board/>
    </div>
    <div class="d-flex">
      <el-row class="w-100">
        <el-col>
          <div class="d-flex mxw-820" :class="{'padding-right':isLaptop, 'padding-right-2':isBigLaptop, 'padding-right-3':isSmallLaptop }">
            <content-header :title="`Welcome, ${userName}!`" :noDivider="true" :sub-title="subTitle" class="px-15" />
          </div>
          <div class="px-15">
            <el-divider class="px-15" />
            <!-- <el-badge :value="cartCount" class="fs-20 mt-05 mr-05 pointer" @click.native="onCartClick">
              <i class="el-icon-shopping-cart-2"></i>
            </el-badge> -->
          </div>
          <!-- member board aligned to the right side -->
        </el-col>
      </el-row>
    </div>
    <!-- Featured section with context for new users -->
    <div class="featured-container" id="featured-section">
      <el-row>
        <el-col :span="24">
          <feature-list />
        </el-col>
      </el-row>
    </div>
    <div class="">
      <el-row>
        <el-col :span="24">
          <div class="instruction-section" id="search-section">
            <div class="section-explanation">
              <p class="instruction-text">
                To begin, select Search to select from all registration options. Or choose personalisation options below for specific filtering. These can be edited in the Search filters.
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <el-button class="search-button primary-action" @click="navigateToSearch">
              <i class="el-icon-search"></i>
              Search Registration Options
            </el-button>
          </div>
          <!-- Renewal notifications below search button -->
          <div class="renewal-container-main" v-if="!isTabletAndSmaller">
            <renewal-notifications />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <onboarding-step-1 />
        </el-col>
      </el-row>
    </div>

    <!-- Onboarding Tour -->
    <onboarding-tour
      :is-active="showOnboardingTour"
      @tour-completed="handleTourCompleted"
      @tour-skipped="handleTourSkipped"
      @tour-closed="handleTourClosed"
    />

    <!-- Tour trigger button for returning users -->
    <div v-if="hasCompletedOnboarding" class="tour-trigger">
      <el-button
        type="text"
        @click="restartTour"
        class="restart-tour-button"
      >
        <i class="el-icon-question"></i>
        Help
      </el-button>
    </div>
  </div>
</template>

<script>
// import MemberBoard from '../../components/members/MemberBoard.vue';
// import { getContrastColor } from '@/utils/helpers';
import featureList from '../../components/others/FeatureList.vue';
import memberBoard from '../../components/members/NewMemberBoard.vue';
import onboardingStep1 from '../../components/onboarding/onboarding-step-1.vue';
import renewalNotifications from '../../components/dashboard/RenewalNotifications.vue';
import onboardingTour from '../../components/onboarding/OnboardingTour.vue';
import { hasCompletedOnboarding, markOnboardingCompleted, trackOnboardingStep } from '../../utils/onboarding';

// Development testing utilities
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-unused-expressions
  import('../../utils/onboarding-test');
}

export default {
  name: 'Dashboard',
  components: {
    // MemberBoard,
    onboardingStep1,
    featureList,
    memberBoard,
    renewalNotifications,
    onboardingTour,
  },
  // props: {
  //   entityLevel: String,
  //   entityName: String,
  // },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // Auto-start onboarding tour for new users
    this.$nextTick(() => {
      if (!this.hasCompletedOnboarding) {
        setTimeout(() => {
          this.startOnboardingTour();
        }, 1000); // Small delay to let the page settle
      }
    });
    // let textColorPrimary = '';
    // let textColorSecondary = '';
    // console.log('entityLevel', this.entityLevel);
    // console.log('entityName', this.entityName);
    // if (this.entityLevel && this.entityName) {
    //   await this.$store.dispatch('national/getSlugBranding', { entityLevel: this.entityLevel, entityName: this.entityName });
    //   const meta = this.$store.getters['national/getMeta'];
    //   if (meta && meta.primaryColor && meta.secondaryColor) {
    //     textColorPrimary = getContrastColor(meta.primaryColor);
    //     textColorSecondary = getContrastColor(meta.secondaryColor);
    //     document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
    //     document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
    //   } else {
    //     textColorPrimary = getContrastColor(meta.primaryColor);
    //     textColorSecondary = getContrastColor(meta.secondaryColor);
    //     document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
    //     document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    //   }
    // } else {
    //   this.$store.commit('national/resetCustom', {});
    //   textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
    //   textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
    //   document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
    //   document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    // }
    // document.documentElement.style.setProperty('--text-color-primary', textColorPrimary);
    // document.documentElement.style.setProperty('--text-color-secondary', textColorSecondary);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  data() {
    return {
      openMemberBoardDrawer: false,
      showingFeature: true,
      isTabletAndSmaller: false,
      isLaptop: false,
      isBigLaptop: false,
      isSmallLaptop: false,
      memberBoardExpanded: false, // Track member board expansion state
      showOnboardingTour: false, // Control tour visibility
      // subTitle: "To your right  are all the member profiles belonging to this account. If you do not have a member profile  click on Add Member to find previous profiles or register a new profile. Once created, you can view a profile's information and registration history. To register a profile to an event or a membership, click on Register",
    };
  },
  methods: {
    handleResize() {
      this.isTabletAndSmaller = window.innerWidth <= 992;
      this.isBigLaptop = window.innerWidth > 1280 && window.innerWidth <= 1440;
      this.isLaptop = window.innerWidth <= 1280 && window.innerWidth > 1130;
      this.isSmallLaptop = window.innerWidth <= 1130 && window.innerWidth > 992;
    },
    onCartClick() {
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      if (this.cartCount > 0) this.$router.push({ name: pathName });
    },
    navigateToSearch() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      console.log('pathName', pathName);
      this.$router.push({ name: pathName });
    },
    handleMemberBoardStateChange(isExpanded) {
      this.memberBoardExpanded = isExpanded;
    },

    // Tour methods
    startOnboardingTour() {
      this.showOnboardingTour = true;
      trackOnboardingStep('tour_started', 'started');
    },

    restartTour() {
      this.showOnboardingTour = true;
      trackOnboardingStep('tour_restarted', 'restarted');
    },

    handleTourCompleted() {
      this.showOnboardingTour = false;
      markOnboardingCompleted();
      trackOnboardingStep('tour_completed', 'completed');
      this.$message.success('Welcome! You\'re all set to start registering.');
    },

    handleTourSkipped() {
      this.showOnboardingTour = false;
      markOnboardingCompleted();
      trackOnboardingStep('tour_skipped', 'skipped');
    },

    handleTourClosed() {
      this.showOnboardingTour = false;
      trackOnboardingStep('tour_closed', 'closed');
    },
  },

  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    cartCount() {
      return this.$store.getters['cart/counts'];
    },
    userName() {
      return this.$store.getters['user/userName'];
    },
    responsiveCol() {
      return {
        xs: 12, sm: 12, md: 12, lg: 20
      };
    },
    hasCompletedOnboarding() {
      const userMeta = this.$store.getters['user/getUserMeta'];
      return hasCompletedOnboarding(userMeta);
    },
    subTitle() {
      if (!this.hasCompletedOnboarding) {
        return 'Register for sports events and memberships in your area. We\'ll guide you through the process.';
      }

      // Simplified subtitle for returning users
      if (this.isTabletAndSmaller) {
        return 'Your member profiles are shown above. Add members or register them for events and memberships.';
      }
      return 'Your member profiles are on the right. Add members or register them for events and memberships.';
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-container{
  position: relative;

  // Mobile padding adjustments

  .section-explanation {
    text-align: center;
    margin-bottom: 2rem;
    padding: 0 2rem;

    h3 {
      font-size: 1.5rem;
      font-weight: 600;
      color: #333;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 1rem;
      line-height: 1.5;
      color: #666;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  .instruction-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin:  1rem 0;
    padding: 0 2rem;

    .instruction-text {
      text-align: center;
      font-size: 1rem;
      line-height: 1.5;
      color: #666;
      max-width: 600px;
      margin: 0;
    }
  }

  .search-button {
    background: var(--secondary-color);
    color: var(--text-color-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    margin-top: 1rem;
    padding: 1rem 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &.primary-action {
      transform: scale(1);
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }

    i {
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
  }
  .member-board{
    margin-top: 1rem;
      min-width: 300px;
      position: fixed !important;
      top: 80px;
      right: 0;
      z-index: 1000;
    // height:100%
  }
  .member-board-small-screensize{
    // Enhanced mobile positioning with sticky behavior
    position: sticky;
    top: 50px; // Below navigation
    z-index: 100;
    background: white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin: 0 auto;
    width: 95%;
    max-width: 100%;
    overflow-x: hidden;

    @media only screen and (max-width: 576px) {
      margin: 0 auto;
      width: 100%;
      border-radius: 0; // Remove border radius on very small screens
    }
  }
  // Welcome section enhancement for mobile
  .d-flex .el-row .el-col .d-flex {
    @media (max-width: 768px) {
      padding: 20px 15px;
      margin-top: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
  }

  .featured-container{
    // width: 100%;
    // width: 992px;
    margin: 0 auto;
    // height: 450px !important;
    padding:0 0.5rem;
  }

  .renewal-container-main{
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
  }

  .renewal-container-mobile{
    padding: 0 0.5rem;
  }
  .padding-right{
    padding-right: 10rem;
  }
  .padding-right-2{
    padding-right: 5rem;
  }
  .padding-right-3{
    padding-right: 15rem;
  }
  .floating-cart {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px 10px 0px 10px;
    z-index: 1000;
    cursor: pointer;
  }

  .tour-trigger {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;

    .restart-tour-button {
      background: white;
      border: 1px solid #ddd;
      border-radius: 20px;
      padding: 0.5rem 1rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-color: var(--highlight-color, #409eff);
        color: var(--highlight-color, #409eff);
      }

      i {
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
